import React, { useState, useEffect } from "react";
import ReactCompareImage from "react-compare-image";
import "./BeforeAfterShowcase.css";

// Import all before/after image pairs
import oldmanBefore from "../../assets/before_after/oldman_withBg.jpg";
import oldmanAfter from "../../assets/before_after/oldman_withoutBg.png";
import bikeBefore from "../../assets/before_after/bike_before.png";
import bikeAfter from "../../assets/before_after/bike_after.png";
import mercedesBefore from "../../assets/before_after/mercedes_maybach_before.png";
import mercedesAfter from "../../assets/before_after/mercedes_maybach_after.png";
import tigerBefore from "../../assets/before_after/tiger_withBg.jpg";
import tigerAfter from "../../assets/before_after/tiger_withoutBg.png";

const BeforeAfterShowcase = () => {
  const showcases = [
    {
      id: 0,
      name: "Old Man",
      before: oldmanBefore,
      after: oldmanAfter,
    },
    {
      id: 1,
      name: "Bike",
      before: bikeBefore,
      after: bikeAfter,
    },
    {
      id: 2,
      name: "Mercedes-Maybach",
      before: mercedesBefore,
      after: mercedesAfter,
    },
    {
      id: 3,
      name: "Tiger",
      before: tigerBefore,
      after: tigerAfter,
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);
  const [progress, setProgress] = useState(0);

  // Auto-rotate every 15 seconds with progress tracking
  useEffect(() => {
    if (!autoPlay) {
      setProgress(0);
      return;
    }

    let elapsedTime = 0;
    const interval = setInterval(() => {
      elapsedTime += 100;
      const newProgress = (elapsedTime / 15000) * 100;
      setProgress(Math.min(newProgress, 100));

      if (elapsedTime >= 15000) {
        setCurrentIndex((prev) => (prev + 1) % showcases.length);
        elapsedTime = 0;
        setProgress(0);
      }
    }, 100);

    return () => {
      clearInterval(interval);
      setProgress(0);
    };
  }, [autoPlay, showcases.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setAutoPlay(false); // Pause auto-play when user manually selects
    // Resume auto-play after 10 seconds of inactivity
    const resumeTimer = setTimeout(() => setAutoPlay(true), 10000);
    return () => clearTimeout(resumeTimer);
  };


  const current = showcases[currentIndex];

  return (
    <div className="before-after-showcase">
      {/* Main slider */}
      <div className="showcase-slider-container">
        <ReactCompareImage
          key={current.id}
          leftImage={current.after}
          rightImage={current.before}
          sliderPositionPercentage={0}
          sliderLineColor="#ffffff"
          sliderLineWidth={3}
          handleSize={40}
          hover={true}
          aspectRatio="wider"
        />
      </div>

      {/* Simple dots indicator */}
      <div className="showcase-indicators">
        {showcases.map((showcase, index) => (
          <button
            key={showcase.id}
            className={`dot ${index === currentIndex ? "active" : ""}`}
            onClick={() => goToSlide(index)}
            title={`Go to ${showcase.name}`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Auto-play toggle */}
      <button 
        className={`autoplay-toggle ${autoPlay ? "playing" : "paused"}`}
        onClick={() => setAutoPlay(!autoPlay)}
        title={autoPlay ? "Pause auto-play" : "Resume auto-play"}
        style={{
          '--progress': `${progress}%`
        }}
      >
        <span className="autoplay-progress" style={{
          background: `conic-gradient(#4F46E5 0deg ${(progress / 100) * 360}deg, rgba(255, 255, 255, 0.2) ${(progress / 100) * 360}deg 360deg)`
        }}></span>
        <span className="autoplay-icon">{autoPlay ? "⏸" : "▶"}</span>
      </button>
    </div>
  );
};

export default BeforeAfterShowcase;
